module.exports = __webpack_public_path__ + "static/media/loading-program-image.cc05ed8f.png";